var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.0001C26.6275 32.0001 32 26.6275 32 20.0001C32 13.3727 26.6275 8 20 8C13.3726 8 8 13.3727 8 20.0001C8 26.6275 13.3726 32.0001 20 32.0001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9321 26.7143V19.248",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9334 13C19.7488 13 19.5684 13.0548 19.4149 13.1573C19.2614 13.2598 19.1417 13.4056 19.071 13.5761C19.0004 13.7467 18.9819 13.9343 19.0179 14.1154C19.0539 14.2964 19.1428 14.4628 19.2733 14.5933C19.4039 14.7239 19.5702 14.8127 19.7512 14.8487C19.9323 14.8847 20.12 14.8662 20.2905 14.7956C20.4611 14.7249 20.6068 14.6053 20.7094 14.4518C20.8119 14.2983 20.8666 14.1178 20.8666 13.9332C20.8666 13.6858 20.7682 13.4484 20.5932 13.2734C20.4183 13.0984 20.1809 13 19.9334 13",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.770e211d7f47be3805db77d73c6d4eb9.svg";
export { ForwardRef as ReactComponent };